import React from 'react'

const DocumentUploadEdit = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M16.6801 3.9557L5.2801 15.2957L3.6001 20.3957L8.7001 18.7157L16.6801 10.7357L15.8401 9.8957L8.7001 16.9757L7.0201 15.2957L15.0001 7.3157L17.5201 9.8357L20.0401 7.3157C20.5201 6.8357 20.5201 6.1157 20.0401 5.6357L18.3601 3.9557C17.8801 3.4757 17.1001 3.4757 16.6801 3.9557ZM7.73995 17.7568L6.47995 18.1768L5.81995 17.5168L6.23995 16.2568L7.73995 17.7568ZM15.8401 6.53688L17.5201 8.21688L19.2001 6.47687L17.5201 4.79688L15.8401 6.53688Z"
            fill="#0562D2"
        />
    </svg>
)

export default DocumentUploadEdit
